import { render } from "./storage_recording.vue?vue&type=template&id=e6ccd53a&scoped=true"
import script from "./storage_recording.vue?vue&type=script&lang=js"
export * from "./storage_recording.vue?vue&type=script&lang=js"

import "./storage_recording.vue?vue&type=style&index=0&id=e6ccd53a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ccd53a"]])

export default __exports__